<!--
  班级统计
-->
<template>
  <div class="SubWebPage" v-loading.fullscreen.lock="fullscreenLoading">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card class="box-card">
          <div class="card-body">

            <div class="divSeachBox">
              <div class="divItemBox">
                <el-select v-model="semesterId" placeholder="请选择学期" @change="onSemester">
                  <el-option v-for="item in optSemester" :key="item.semesterId" :label="item.name"
                    :value="item.semesterId">
                  </el-option>
                </el-select>
              </div>
              <div class="divItemBox">
                <el-select v-model="weekIndex" placeholder="请选择校历周" clearable @change="onWeek">
                  <el-option v-for="item in optWeek" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :md="24" v-for="(item, index) in items" :key="index">
        <el-card class="box-card">
          <div slot="header" class="card-header">
            <h3 class="card-title">
              {{item.collegeName}}
            </h3>
          </div>
          <div class="card-body">
            <el-row :gutter="30">
              <el-col :md="6" :sm="12">
                <div class="cardTypeLable">
                  <div class="card-body">
                    <div class="typeLabelBox clearfix">
                      <div class="leftBox VerticalMid">
                        <div class="iconBox VerticalMid labelColor_1">
                          <svg class="icon" aria-hidden="true">
                            <use xlink:href="#fax-paper-plane-alt"></use>
                          </svg>
                        </div>
                      </div>
                      <div class="rightBox">
                        <div class="numberBox">{{item.activity}}<span class="spUnit">次</span></div>
                        <div class="typeName">参与活动</div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :md="6" :sm="12">
                <div class="cardTypeLable">
                  <div class="card-body">
                    <div class="typeLabelBox clearfix">
                      <div class="leftBox VerticalMid">
                        <div class="iconBox VerticalMid labelColor_2">
                          <svg class="icon" aria-hidden="true">
                            <use xlink:href="#fax-trophy-alt"></use>
                          </svg>
                        </div>
                      </div>
                      <div class="rightBox">
                        <div class="numberBox">{{item.prize}}<span class="spUnit">次</span></div>
                        <div class="typeName">竞赛获奖</div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :md="6" :sm="12">
                <div class="cardTypeLable">
                  <div class="card-body">
                    <div class="typeLabelBox clearfix">
                      <div class="leftBox VerticalMid">
                        <div class="iconBox VerticalMid labelColor_4">
                          <svg class="icon" aria-hidden="true">
                            <use xlink:href="#fax-file-punish"></use>
                          </svg>
                        </div>
                      </div>
                      <div class="rightBox">
                        <div class="numberBox">{{item.punish}}<span class="spUnit">次</span></div>
                        <div class="typeName">处分记录</div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :md="6" :sm="12">
                <div class="cardTypeLable">
                  <div class="card-body">
                    <div class="typeLabelBox clearfix">
                      <div class="leftBox VerticalMid">
                        <div class="iconBox VerticalMid labelColor_6">
                          <svg class="icon" aria-hidden="true">
                            <use xlink:href="#fax-hotel-alt"></use>
                          </svg>
                        </div>
                      </div>
                      <div class="rightBox">
                        <div class="numberBox">{{item.dormitoryLog}}<span class="spUnit">次</span></div>
                        <div class="typeName">宿舍记录</div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
      <el-col :md="24">
        <el-card class="box-card">
          <div slot="header" class="card-header">
            <h3 class="card-title">
              全校学生门禁情况
            </h3>
            <div class="card-tools">
              <ul class="nav nav-pills ml-auto">
                <li class="nav-item">
                  <el-button type="success" size="small" icon="el-icon-s-data" @click="onDetail()">详情</el-button>
                </li>
              </ul>
            </div>
          </div>
          <div class="card-body">
            <comBar v-if="items.length>0" :comID="'refDoorAccess'" :comData="items" ref="refDoorAccess"></comBar>
          </div>
        </el-card>
      </el-col>
      <el-col :md="24">
        <el-card class="box-card">
          <div slot="header" class="card-header">
            <h3 class="card-title">
              全校学生请假情况
            </h3>
          </div>
          <div class="card-body">
            <comBar v-if="items.length>0" :comID="'refLeave'" :comData="items" ref="refLeave"></comBar>
          </div>
        </el-card>
      </el-col>
    </el-row>


    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="95%" :before-close="handleClose">
      <div class="divListBox" v-for="(item,index) in items" :key="index">
        <div class="divTitle">
          <svg class="icon" aria-hidden="true" :style="'color:'+optColor[index]+' ;'">
            <use xlink:href="#fax-dot-circle-o"></use>
          </svg>
          {{item.collegeName}}
        </div>
        <comBarDoorAccess :comID="'doorAccess'+index" :ref="'doorAccess'+index" :comBgColor="optColor[index]">
        </comBarDoorAccess>
      </div>
    </el-dialog>



  </div>
</template>

<script>
  import '@/assets/css/Admin.css';
  import comBar from '@/components/Report/statistics/bar.vue';
  import comBarDoorAccess from '@/components/Report/statistics/bar_dooraccess.vue';
  export default {
    components: {
      comBar,
      comBarDoorAccess
    },
    data() {
      return {
        fullscreenLoading: false,
        leavePercType: '0',
        leaveNumType: '1',
        semesterId: null,
        weekIndex: null,
        optSemester: [],
        optWeek: [],
        items: [],
        // 颜色数组
        optColor: ['#7E66F6', '#3191D9', '#4FBD76', '#F9BB4A', '#F50737',
          '#8CB93D', '#3AAF9D', '#4261E4', '#A75CE7', '#6610f2',
          '#e83e8c', '#fd7e14', '#28a745', '#17a2b8'
        ],

        dialogTitle: null,
        dialogVisible: false,
      };
    },
    created() {
      let that = this;
      ajaxGet(that, "/api/admin/semester", null, function(res) {
        that.optSemester = res;
        that.optSemester.forEach(element => {
          if (element.isCurrent) {
            that.semesterId = element.semesterId;
            that.onSemester(element.semesterId);
            GetStatistics(that);
          }
        })
      });
    },
    methods: {
      onDetail() {
        let that = this;
        that.dialogVisible = true;
        that.dialogTitle='';
        let tpSemester = that.optSemester.find(item => item.semesterId == that.semesterId);
        let tpWeek=that.optWeek.find(item=> item.value==that.weekIndex);
        if (!regNull(tpSemester)) {
          that.dialogTitle += tpSemester.name;
        }
        if(!regNull(tpWeek)){
          that.dialogTitle += '（'+tpWeek.label+'）';
        }
      },
      /**
       * @description 搜索
       */
      handleClose() {
        let that = this;
        that.dialogVisible = false;
      },
      onSemester(val) {
        let that = this;
        that.optWeek = [];
        that.weekIndex = null;
        GetStatistics(that);
        if (val) {
          ajaxGet(that, "/api/admin/semesterday/week/" + val, null, function(r) {
            var list = [];
            for (var i = 0; i < r; i++) {
              var newWeek = {
                value: i + 1,
                label: '第' + (i + 1) + '周'
              }
              list.push(newWeek);
            }
            that.optWeek = list;
          })
        }
      },
      onWeek() {
        let that = this;
        GetStatistics(that);
      },
    },
  };

  function GetStatistics(that) {
    let data = {
      SemesterId: that.semesterId,
      weekIndex: that.weekIndex
    }
    ajaxGet(that, "/api/admin/statistics/collegestatistics", data, function(r) {
      that.items = r;
    })

  }
</script>

<style scoped="scoped" lang="less">
  .divListBox {
    margin-bottom: 50px;

    .divTitle {
      font-size: 24px;
      color: #303333;
      padding-left: 50px;
    }
  }

  .divSeachBox {
    width: 700px;
    margin: 0 auto;
    display: flex;

    .divItemBox {
      margin-left: 5px;
      margin-right: 5px;
    }
  }

  .cardTypeLable {
    border: 2px solid #FFFFFF;

    &:hover {
      cursor: pointer;
      border: 2px solid #3364FF;
    }

    .typeLabelBox {
      height: 80px;

      .rightBox {
        float: left;
      }

      .leftBox {
        text-align: center;
        width: 100px;
        height: 80px;
        float: left;
      }

      .numberBox {
        color: #323D56;
        font-family: 'OswaldLight';
        font-size: 34px;
        letter-spacing: 1px;
        font-weight: bold;

        .spUnit {
          font-size: 18px;
          padding-left: 5px;
        }
      }

      .iconBox {
        background-color: #EEEEEE;
        color: #000000;
        width: 70px;
        height: 70px;
        border-radius: 50%;

        .icon {
          font-size: 34px;
        }
      }

      .typeName {
        color: #ACB2C6;
        letter-spacing: 1px;
      }

      .labelColor_1 {
        background-color: #E5FBFA;
        color: #17DCCD;
      }

      .labelColor_2 {
        background-color: #EAEFFF;
        color: #3364FF;
      }

      .labelColor_3 {
        background-color: #FFF5F8;
        color: #FFA1C0;
      }

      .labelColor_4 {
        background-color: #FFF8EB;
        color: #FFBC20;
      }

      .labelColor_5 {
        background-color: #E9FBE5;
        color: #3DDC18;
      }

      .labelColor_6 {
        background-color: #FFEAF4;
        color: #FF3368;
      }

      .labelColor_7 {
        background-color: #EAFFFE;
        color: #33C1FF;
      }


    }
  }








  label {
    margin-bottom: 0;
  }
</style>
